

<script>
import AddressSection from './AddressSection';

export default {
	name: 'PostAndPrintShippingRequest',
	props: ['step'],
	data () {
		return {
			shouldSaveSenderInformation: false,
			LOCALSTORAGENAME: 'postAndPrintShipmentSenderInformation',
			...this.getInitialUserFieldsState()
		}
	},
	components: {
		AddressSection,
	},
	watch: {
		shouldSaveSenderInformation (shouldSave){
			if( shouldSave ){
				this.saveSenderInformation();
			} else {
				this.removeSavedSenderInformation();
			}
		},
		senderInformation: {
			deep: true,
			handler: function(){
				if( this.shouldSaveSenderInformation ){
					this.saveSenderInformation();
				}
			},
		},
	},
	computed: {
		senderAddressIsReasonable () {
			return this.isAddressReasonable('senderInformation');
		},
		recipientAddressIsReasonable () {
			return this.isAddressReasonable('packageInformation');
		},
		isSenderInformationEmpty(){
			const defaultData = this.getInitialUserFieldsState();
			return JSON.stringify(defaultData.senderInformation) == JSON.stringify(this.senderInformation);
		},
		isPackageInformationEmpty(){
			const defaultData = this.getInitialUserFieldsState();
			return JSON.stringify(defaultData.packageInformation) == JSON.stringify(this.packageInformation);
		},
		requiredFieldsMissed(){
			var missed = [];
			if( this.senderInformation.name == '' )
				missed.push('Sender name');
			if( this.senderInformation.email == '' )
				missed.push('Sender email');
			if( this.senderInformation.phone == '' )
				missed.push('Sender phone');
			if( this.senderInformation.senderType == '' )
				missed.push('Sending for self/Bates');
			if( this.senderInformation.address.street == '' )
				missed.push('Sender street address');
			if( this.senderInformation.address.city == '' )
				missed.push('Sender city');
			if( this.senderInformation.address.country == '' )
				missed.push('Sender country');
			if( this.packageInformation.name == '' )
				missed.push('Recipient name');
			if( this.packageInformation.phone == '' )
				missed.push('Recipient phone');
			if( this.packageInformation.address.street == '' )
				missed.push('Recipient street address');
			if( this.packageInformation.address.city == '' )
				missed.push('Recipient city');
			if( this.packageInformation.address.country == '' )
				missed.push('Recipient country');

			return missed;
		}
	},
	methods: {
		setMessage(msg){
			this.$emit('update:message',msg);
		},
		setStep(step){
			this.$emit('update:step',step);
		},
		isAddressReasonable (whichAddress){
			var reasonable = true;
			if( 
				this[whichAddress].address.street == '' 
				||
				this[whichAddress].address.city == ''
				||
				this[whichAddress].address.state == ''
			) {
				reasonable = false;
			}
			return reasonable;
		},
		/* Save sender information to browser
		*/
		checkIfSavedSenderInformation(){
			return( this.getSavedSenderInformation() !== false );
		},
		saveSenderInformation(){
			var si = JSON.stringify(this.senderInformation);
			window.localStorage.setItem( this.LOCALSTORAGENAME, si );
		},
		getSavedSenderInformation(){
			var s = window.localStorage.getItem(this.LOCALSTORAGENAME );
			if( ! s )
				return false;
			return JSON.parse(s);
		},
		removeSavedSenderInformation(){
			window.localStorage.removeItem(this.LOCALSTORAGENAME);
			this.setMessage('Stopped remembering sender information');
		},
		updateSenderAddress(addressPart, val){
			this.senderInformation.address[ addressPart ] = val;
			if( this.shouldSaveSenderInformation ){
				this.saveSenderInformation();
			}
		},
		updateRecipientAddress(addressPart, val){
			this.packageInformation.address[ addressPart ] = val;
		},
		clearSender(){
			const cleanData = this.getInitialUserFieldsState();
			for(let key in cleanData.senderInformation) {
				this.senderInformation[key] = cleanData.senderInformation[key];
			}
			// this.removeSavedSenderInformation();
			// this.shouldSaveSenderInformation = false;
		},
		clearPackage(){
			const cleanData = this.getInitialUserFieldsState();
			for(let key in cleanData.packageInformation) {
				this.packageInformation[key] = cleanData.packageInformation[key];
			}
			this.packageContents = cleanData.packageContents;
		},
		clearAll() {
			
			this.clearPackage();

			if( this.shouldSaveSenderInformation ) {
				this.setStep(2);
			} else {
				this.clearSender();
				this.setStep(1);
			}
		},
		finish ( clearForm=false ) {
			if( clearForm ){
				this.clearAll();
			} else {
				this.setStep(2);
			}
			window.print();
		},
	},
	created () {
		const savedSenderData = this.getSavedSenderInformation();
		if( savedSenderData ){
			this.senderInformation = savedSenderData;
			this.shouldSaveSenderInformation = true;
			this.setStep(2);
		}
	}
}
</script>

<template>
<main class="columns">

	<form class="left-column column">

		<transition name="fade" mode="out-in">
			<div class="step active" v-if="step==1">
				<h1>About You</h1>

				<label class="block req" for="sender-name">Your Name</label>
				<input type="text" id="sender-name" v-model="senderInformation.name" autocomplete="off" tabindex="5" required autofocus>

				<label for="sender-email" class="req block">Email</label>
				<input type="email" id="sender-email" v-model="senderInformation.email" autocomplete="off" tabindex="10" required placeholder="you@bates.edu">

				<label for="sender-phone" class="req block">Phone</label>
				<input type="tel" pattern="[0-9- ()]*" v-model="senderInformation.phone" value="" autocomplete="off" tabindex="15" required placeholder="207-555-5555">

				<label class="req block">Are you sending this for yourself or for Bates?</label>
				<div class="radio-wrap">
					<input 
						type="radio" 
						id="sender-type-personal" 
						value="personal" 
						autocomplete="off" 
						tabindex="20"
						v-model="senderInformation.senderType"
					>
					<label for="sender-type-personal"> Personal</label>
				</div>
				<div class="radio-wrap">
					<input 
						type="radio" 
						id="sender-type-org" 
						value="org" 
						autocomplete="off" 
						tabindex="25"
						v-model="senderInformation.senderType"
					>
					<label for="sender-type-org"> Bates</label>
				</div>

				<transition name="slideDown">
					<div class="org-info-wrap" v-if="senderInformation.senderType=='org'">
						<label for="org-number" class="req block">Bates ORG #</label>
						<input type="text" v-model="senderInformation.department.orgNumber" autocomplete="off" tabindex="30">

						<label for="sender-department" class="block">Bates Department</label>
						<input type="text" v-model="senderInformation.department.departmentName" autocomplete="off" tabindex="32">
					</div>
				</transition>

				<AddressSection 
					:currentAddress="senderInformation.address"
					@update="updateSenderAddress" 
					@address-not-verified="setMessage('Cannot verify that address with Postal Service.')" 
					firstTabIndex="33"
					key="sender-address"
				/>

				<div class="remember-me">
					<input type="checkbox" v-model="shouldSaveSenderInformation" id="should-save-sender-information"> 
					<label for="should-save-sender-information">Save this information for later</label>
					<br>
					<i>Do <b>not</b> select on a public computer</i>.
				</div>

				<p class="button-wrap">
					<a 
						class="button next " 
						href="#" 
						tabindex="65" 
						@click="setStep(2)"
					>Package Information</a>
				</p>

			</div>
			<div class="step" v-else-if="step==2">

				<h1>About Your Package</h1>
			
				<label class="block req" for="recipient-name">Recipient's Name</label>
				<input type="text" autocomplete="off" tabindex="70" required v-model="packageInformation.name">
				
				<label for="recipient-email" class="block">Email</label>
				<input type="email" autocomplete="off" tabindex="75" placeholder="them@gmail.com" v-model="packageInformation.email">

				<label for="recipient-phone" class="req block">Phone</label>
				<input type="tel" pattern="[0-9- ()]*" autocomplete="off" tabindex="80" required placeholder="207-555-5555" v-model="packageInformation.phone">

				<AddressSection
					:currentAddress="packageInformation.address"
					@update="updateRecipientAddress"
					@address-not-verified="setMessage('Cannot verify that address with Postal Service.')" 
					firstTabIndex="81"
					key="recipient-address"
				/>

				<label class="block" for="package-contents">Package Contents</label>
				<textarea autocomplete="off" tabindex="115" v-model="packageContents"></textarea>

				<p class="button-wrap">
					<a 
						class="button back" 
						href="#" 
						tabindex="125" 
						@click="setStep(1)"
					>Sender Information</a>
					<a 
						class="button next" 
						href="#" 
						tabindex="120" 
						@click="setStep(3)"
					>Review</a>
				</p>
			</div>

			<div class="step" v-else-if="step==3">

				<div class="errors-in-information" v-if=" ! senderAddressIsReasonable || ! recipientAddressIsReasonable || requiredFieldsMissed.length ">
					<h1>Problems Detected</h1>
					<p>There were some problems with the information.</p>
					<p v-if=" ! senderAddressIsReasonable">The sender information doesn't look quite right. Please <a href="#" @click="setStep(1)">go back and check it</a>.</p>
					<p v-if=" ! recipientAddressIsReasonable">The information about your package doesn't look quite right. Please <a href="#" @click="setStep(2)">go back and take a look</a>.</p>
					<div v-if="requiredFieldsMissed.length">
						<p>You've missed these required fields:</p>
						<ul>
							<li v-for="(f,k) in requiredFieldsMissed" :key="k">{{ f }}</li>
						</ul>
					</div>
				</div>
				<div v-else>
					<h1>Review</h1>
					<p>Double check everything. If it looks good, click Finish to print your request. <span v-if="! shouldSaveSenderInformation">Click "Finish and Create Another" to create another label with the same sender information.</span>

					<p class="button-wrap">
						<a 
							class="button back" 
							id="fix-something" 
							href="#" 
							tabindex="135" 
							@click="setStep(1)"
						>Modify Sender Information</a>
						<a 
							class="button back" 
							id="fix-something" 
							href="#" 
							tabindex="135" 
							@click="setStep(2)"
						>Modify Package Information</a>

					</p>
				</div>
			</div>
		</transition>

	</form>
	<div class="right-column column">

		<div id="summary">

			<div class="global-button-wrap summary-panel">
				<p class="small-links">
					<a 
						href="#" 
						@click="() => {removeSavedSenderInformation();this.shouldSaveSenderInformation=false;}"  
						v-if="shouldSaveSenderInformation" 
					>Clear saved sender information</a>
				</p>
				<span v-if="requiredFieldsMissed.length==0 && senderAddressIsReasonable && recipientAddressIsReasonable">
					<a 
						class="button" 
						href="#" 
						id="create-another" 
						@click="finish()"
						v-if=" ! shouldSaveSenderInformation"
					>Finish and Create Another</a>
					<a 
						class="button finish" 
						id="submit" 
						href="#" 
						@click="finish(true)"
					>Finish</a>
				</span>
				<a 
					href="#" 
					class="button delete" 
					@click.prevent="clearAll"
					v-if=" (!isSenderInformationEmpty || !isPackageInformationEmpty)" 
				>Clear Form</a>
			</div>

			<div class="summary-panel" id="summary-sender">
				<h3>About You</h3>
				<p class="small-links"
					v-if="! isSenderInformationEmpty && step != 1"
				>
					<a href="#" @click="setStep(1)">Modify Sender Information</a>
				</p>
				<div class="summary-panel-inner">
					<p class="summary-name">{{ senderInformation.name }}</p>
					<p class="summary-email">{{ senderInformation.email }}</p>
					<p class="summary-phone">{{ senderInformation.phone }}</p>
					<p class="summary-department-wrap" v-if="senderInformation.senderType=='org'">
						<span class="summary-org-number">{{ senderInformation.department.orgNumber }}</span>&nbsp;
						<span class="summary-department" v-if="senderInformation.department.departmentName">({{ senderInformation.department.departmentName }})</span>
					</p>
					<div class="summary-address-wrap" v-if="senderInformation.address.street!=''">
						<p v-html="$options.filters.nl2br(senderInformation.address.street)"></p>
						<p v-if="senderInformation.address.city">
							<span>{{ senderInformation.address.city }}</span>, 
							<span>{{ senderInformation.address.state }}</span>&nbsp;
							<span>{{ senderInformation.address.zip }}<span v-if="senderInformation.address.zip4">-{{ senderInformation.address.zip4 }}</span></span>
							<br>
							<span>{{ senderInformation.address.country }}</span>
						</p>
					</div>
				</div>
			</div>

			<div class="summary-panel" id="summary-recipient">
				<h3>About Your Package</h3>
				<p class="small-links"
					v-if="! isPackageInformationEmpty && step != 2"
				>
					<a href="#" @click="setStep(2)">Modify Package Information</a>
				</p>
				<div class="summary-panel-inner">
					<p class="summary-name">{{ packageInformation.name }}</p>
					<p class="summary-email">{{ packageInformation.email }}</p>
					<p class="summary-phone">{{ packageInformation.phone }}</p>
					<div class="summary-address-wrap" v-if="packageInformation.address.street != ''">
						<p v-html="$options.filters.nl2br(packageInformation.address.street)"></p>
						<p v-if="packageInformation.address.city">
							<span>{{ packageInformation.address.city }}</span>, 
							<span>{{ packageInformation.address.state }}</span>&nbsp;
							<span>{{ packageInformation.address.zip }}
								<span v-if="packageInformation.address.zip4">-{{ packageInformation.address.zip4 }}</span></span>
							<br>
							<span>{{ packageInformation.address.country }}</span>
						</p>
					</div>
					<p class="summary-package-contents">{{ packageContents }}</p>
				</div>
			</div>
		</div>

	</div>
</main>
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.summary-panel .package-contents {
		font-size:  .9em;
		padding-top: 1em;
		border-top: 1px solid silver;
		font-style: italic;
	}
	.summary-panel .package-contents:empty {
		display:  none;
	}
	.small-links {
		padding:  .4em 0;
		font-size:  .8em;
		text-align: right;
	}
	.remember-me {
		margin: .8em 0;
		padding: .7em;
		background: hsl(0, 0%, 85%);
		border: 1px solid hsl(0, 0%, 70%);
		line-height: 1.4em;
	}
</style>